import history from '../../history';

export const navigateTo = to => {
    if (history.location.pathname !== to) {
        history.push(to);
    }
};
